import { render } from "./AssetPreloader.vue?vue&type=template&id=65541b0e"
import script from "./AssetPreloader.vue?vue&type=script&lang=js"
export * from "./AssetPreloader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__